/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from 'react'

import Menu from '../../../../components/InternalMenu/Menu'

import { ToastContainer } from 'react-toastify'
import { useForm } from "react-hook-form"

import { deleteItem, get, put } from '../../../../services/http'
import { notify } from '../../../../components/Toast'

import { useNavigate, useParams } from 'react-router-dom'

function index() {
  const navigate = useNavigate()

  const [modal, setModal] = useState(false)
  const [cover, setCover] = useState(false)

  const [clickButton, setClickButton] = useState(false)
  const [sliders, setSliders] = useState([{ id : 1 }])
  const [sliderTitle, setSliderTitle] = useState('')

  document.title = 'ویرایش سوالات'

  const { register, handleSubmit, reset } = useForm()

  const token = localStorage.getItem('token')

  const { id } = useParams()

  useEffect(() => {
    get(`/api/admin/im/faq/${id}?token=${token}`).then(response => {
      console.log(response.data.data[0].faq)
      setSliders(response.data.data[0].faq)
      setSliderTitle(response.data.data[0].title)
      let defaultValues = {}
      reset({ ...defaultValues })
    })
  }, [id, reset, token])

  const sliderTitleHandler = (e) => {
    setSliderTitle(e.target.value)
  }

  const onSubmit = (data, e) => {
    e.preventDefault()
    setClickButton(true)

    let count = 0
    const sliderArray = []

    let objectFa
    Object.keys(data).forEach(function(key, index) {
      let object
      count++
      console.log(key, data[key])
      if(count%2 === 1) {
        objectFa = { faqQua: data[key] }
        console.log(object)
      }
      if (count%2 === 0) {
        object = { ...objectFa, faqAns: data[key] }
        sliderArray.push(object)
        object = {}
        objectFa = {}
      }
    })

    console.log(sliderArray)

    put(`/api/admin/im/faq/${id}?token=${token}`, { title: sliderTitle, faq: sliderArray }).then(response => {
        notify('success', response.data.messageFa)
        setTimeout(() => {
          navigate('/im/faq')
        }, 2000)
      }).catch(error => {
        setClickButton(false)
        if (error) {
          notify('error', error)
        }
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }

  const deleteHandler = (e) => {
    deleteItem(`/api/admin/im/faq/${id}?token=${token}`)
      .then(response => {
        setCover(false)
        setModal(false)
        notify('success', response.data.messageFa)
        setTimeout(() => {
          navigate('/im/faq')
        }, 2000)
      })
      .catch(error => {
        if (error) {
          notify('error', error)
        }
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }

  return (
    <main id='panel'>
      <div className="cover" style={{ display: cover? '': 'none' }}>
      </div>
      <div className='deleteModal' style={{ display: modal? '': 'none' }}>
        <div className="textDeleteModal">
          آیا میخواهید اسلایدر مورد نظر حذف شود؟
        </div>
        <hr />
        <div className="buttons">
          <button onClick={deleteHandler}>حذف شود</button>
          <button onClick={e => {
            setCover(false)
            setModal(false)
          }}>انصراف</button>
        </div>
      </div>
      <ToastContainer rtl />
      <Menu page={'faq'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className='right'>
              <div className='text'>
                ایجاد سوالات
              </div>
            </div>

            <div className='left'>
            <button onClick={e => { 
                setCover(true)
                setModal(true) }} style={{ backgroundColor: '#ff6666' }} className='createButton' type='submit'>حذف سوالات</button>
            </div>
          </div>

          <form className='form' onSubmit={handleSubmit(onSubmit)}>
            <div className='title'>
              * برای ایجاد سوال جدید لطفا تمامی فیلد های مشخص شده را پر کنید.
            </div>
            <div className='lineTitle'>
              <hr />
              اطلاعات سوالات
              <hr />
            </div>
            <div className='row'>
              <div className='column' style={{ width: '35%' }}>
                <label htmlFor='resturantDetails' >نام سوالات * :</label>
                <input id='resturantDetails' onChange={sliderTitleHandler} defaultValue={sliderTitle} type='text' placeholder='محصولات ...' />
                <small id='resturantDetailsAlert'>توضیحات باید وارد شود</small>
              </div>
            </div>
            {sliders.map((item, index) => (
              <div className='row' key={index} id={item.id}>
                <div className='column' style={{ width: '35%' }}>
                  <label htmlFor='resturantDay'>سوال * :</label>
                  <input id='resturantDay' {...register(`sliderLink${index}`, { required: true, minLength: 1 })} defaultValue={item.faqQua} type='text' placeholder='لینک' />
                  <small id='resturantDayAlert'>ویژگی باید وارد شود</small>
                </div>
                <div className='column' style={{ width: '62%' }}>
                  <label htmlFor='resturantTime'>جواب * :</label>
                  <textarea id='resturantTime' {...register(`sliderPicture${index}`, { required: true, minLength: 3 })} defaultValue={item.faqAns} type='text' placeholder='لینک تصویر'></textarea>
                  <small id='resturantTimeAlert'>انگلیسی ویژگی باید وارد شود</small>
                </div>
              </div>
            ))}
            {/* <div className="row">
              <div className="add" onClick={timeHandler}>
                +
              </div>
            </div> */}
            <button className='createButton' type='submit' style={clickButton ? { backgroundColor: 'gray' } : {}} disabled={clickButton ? true : false}>{clickButton ? 'در حال آپلود ...' : 'ویرایش سوال'}</button>
          </form>
          <div className='copyright'>
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}

export default index